/* IMPORTANT: This file is auto-generated. Do not modify it directly or changes will be lost. */
window.addEventListener("load",function(){document.location.href.includes("/collections/")&&(document.body.click(),document.body.click())});